import { API_AUTH } from "./common";

const DongTienNhanhApi = {
  list: ({
    iStatus,
    sSearch,
    iPageIndex,
    iPageSize,
    iType,
    sMaNhanVien,
  }) =>
    API_AUTH.get(
      `DongTienNhanh/DanhSachDongTienNhanh?iStatus=${iStatus}&sSearch=${sSearch}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}&iType=${iType}&sMaNhanVien=${sMaNhanVien}`,
      {}
    ),
};

export default DongTienNhanhApi;
